<template>
  <block style="padding-bottom: 30px;">
    <template slot="header">
      Alerta Manual
    </template>

    <div class="msg">
      <h4 class="is-uppercase">Alerta manual registrada exitosamente</h4>
      <p class="is-marginless">Ahora puedes agregar una atención para el estudiante.</p>
    </div>

    <div class="actions">
      <button class="button is-primary" @click="navigateTo('app.profile.add_attention')">
        Sí, agendar atención
      </button>
      <button class="button" @click="navigateTo('app.profile.alerts')">No, volver</button>
    </div>
  </block>
</template>

<script>
import Block from "@/components/_base/Block.vue"
import OverlayedMixin from "@/mixins/OverlayedMixin"

export default {
  name: "ProfileAlertRaised",
  mixins: [OverlayedMixin],
  methods: {
    navigateTo(route) {
      console.log(`Navigating to...${route}`)
      this.$emit("hello", route)
    }
  },
  components: {
    Block
  }
}
</script>

<style scoped>
.msg {
  margin-bottom: 70px;
}
.msg h4 {
  color: #449d7a;
}
</style>
